<template>
    <CqColorPicker :label="label" :modelValue="color" @update:modelValue="updateColor" />
</template>

<script lang="ts">
    import {Component, Vue, Model, Prop} from 'vue-facing-decorator';
    import {CqColorPicker} from '@cquential/ui';
    import {CSSHexColorString} from '@/types';

    @Component({
        components: {
            CqColorPicker,
        },
    })
    export default class ThemeColorSetting extends Vue {
        @Model({type: String}) public color?: CSSHexColorString;
        @Prop({type: String, required: true}) public label!: string;

        public updateColor(value: string | null): void {
            if (value === null) {
                this.color = undefined;
            } else if (value[0] === '#') {
                this.color = value as CSSHexColorString;
            }
        }
    }
</script>
